import Vue from 'vue'
import config from 'client/config'
import socket from 'client/socket'

const filter = require("lodash/filter")

export default function(store) {
  const state = {
    items: [],
    organisationId: undefined,
  };

  const actions = {
    'organisationUsers.get': function(ctx, organisationId) {
      leaveRooms()

      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/organisations/' + organisationId + '/userList').then(result => {
          store.commit('organisationUsers.setItems', result.data)
          store.commit('organisationUsers.setOrganisationId', organisationId)
          setRooms()
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisationUser.update': function(ctx, ouId) {
      return new Promise((resolve, reject) => {
        Vue.http.get(config.root + '/organisationUsers/' + ouId + '/summary').then(result => {
          store.commit('organisationUser.update', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisationUser.create': function(ctx, ou) {
      return new Promise((resolve, reject) => {
        ou.organisationId = state.organisationId
        Vue.http.post(config.root + '/organisations/' + state.organisationId + '/organisationUser', ou).then(result => {
          store.commit('organisationUser.update', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisationUser.save': function(ctx, ou) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(config.root + '/organisationUsers/' + ou.id, ou).then(result => {
          store.commit('organisationUser.update', result.data)
          resolve(result.data)
        }, err => reject(err))
      })
    },
    'organisationUser.remove': function(state, ouId) {
      return new Promise((resolve, reject) => {
        Vue.http.delete(config.root + '/organisationUsers/' + ouId).then(() => {
          store.commit('organisationUser.remove', ouId)
          resolve()
        }, err => reject(err))
      })
    }
  };

  const mutations = {
    "organisationUsers.setItems": function(state, items) {
      Vue.set(state, 'items', items)
    },
    "organisationUsers.setOrganisationId": function(state, organisationId) {
      Vue.set(state, 'organisationId', organisationId)
    },
    "organisationUser.remove": function(state, id) {
      const items = filter(state.items, i => i.id !== id)
      Vue.set(state, 'items', items)
    },
    "organisationUser.update": function(state, ou) {
      const index = state.items.findIndex(i => i.id === ou.id)
      let items = state.items

      if (index >= 0) {
        items.splice(index, 1, ou)
      }
      else {
        items.push(ou)
      }

      Vue.set(state, 'items', items)
    }
  };

  function setRooms() {
    if (state.organisationId) {
      console.log('joining rooms for organisation', 'organisationUser:' + state.organisationId)
      socket.emit('join', 'organisationUser:' + state.organisationId)
    }
  }

  function leaveRooms() {
    if (state.organisationId) {
      socket.emit('leave', 'organisationUser:' + state.organisationId)
    }
  }

  function listener() {
    socket.on('connect', function () {
      setRooms()
    })
    socket.on('organisationUser.update', function(result) {
      console.log('organisationUser update', result)
      if (result.type === 'update') {
        store.dispatch('organisationUser.update', result.data.id)
        return
      }
      if (result.type === 'create') {
        store.dispatch('organisationUser.update', result.data.id)
      }
    })
    socket.on('organisationUser.delete', result => {
      store.commit('organisationUser.remove', result.data)
    })
    socket.emit('join', 'organisationUser.delete')
  }

  store.registerModule('organisationUsers', {
    state: state,
    mutations: mutations,
    actions: actions
  })

  listener()
}
